"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueValuesSortedByArea = exports.getUniqueValuesFromTiffMapping = exports.bucketByEqualCount = void 0;
const countBy_1 = __importDefault(require("lodash/countBy"));
const bucketByEqualCount = (ordered, bucketCount) => {
    const bucketSize = Math.ceil(ordered.length / bucketCount);
    const bucketsEdges = [];
    // push the edge of each bucket into the array
    for (let i = bucketSize - 1; i < ordered.length; i += bucketSize) {
        bucketsEdges.push(ordered[i]);
    }
    // Ensure the last edge is in the array
    if (bucketsEdges.length < bucketCount) {
        bucketsEdges.push(ordered[ordered.length - 1]);
    }
    return bucketsEdges;
};
exports.bucketByEqualCount = bucketByEqualCount;
/**
 * Returns an array of unique raster values based on the tiff mapping provided.
 * Values are sorted alphabetically based on their corresponding tiff mapping value.
 */
const getUniqueValuesFromTiffMapping = (tiffMapping) => {
    const integerToUniqueValueMapping = tiffMapping;
    const uniqueValueToIntegerMapping = {};
    Object.keys(integerToUniqueValueMapping).forEach((i) => {
        uniqueValueToIntegerMapping[integerToUniqueValueMapping[i]] = i;
    });
    return Object.values(integerToUniqueValueMapping)
        .sort()
        .map((uniqueVal) => parseInt(uniqueValueToIntegerMapping[uniqueVal], 10));
};
exports.getUniqueValuesFromTiffMapping = getUniqueValuesFromTiffMapping;
/**
 * Returns an array of unique raster values sorted from largest to smallest area.
 * Relative area for a given unique value is determined by counting up how raster cells have that value.
 * This method assumes that each raster cell has the same area.
 */
const getUniqueValuesSortedByArea = (ordered) => {
    const byCount = (0, countBy_1.default)(ordered);
    return Object.keys(byCount)
        .map((key) => parseInt(key))
        .filter((key) => key !== 0)
        .sort((valA, valB) => byCount[valA] - byCount[valB])
        .reverse();
};
exports.getUniqueValuesSortedByArea = getUniqueValuesSortedByArea;
